import styled, { css } from 'styled-components';

export const ulStyles = css`
	list-style: none;
	font-size: 1.8rem;
	color: ${({ theme }) => theme.colors.textDark};
	padding-inline-start: 3rem;
	margin-bottom: ${({ marginBottom }) => marginBottom || 0};
`;

export const liStyles = css`
	position: relative;
	margin-bottom: 1rem;

	&:before {
		content: '';
		position: absolute;
		left: -3rem;
		top: 1rem;
		height: 6px;
		width: 6px;
		border-radius: 100%;
		background-color: ${props => props.theme.colors.primary};
	}
`;

export const Ul = styled.ul`
	${ulStyles};
`;

export const Li = styled.li`
	${liStyles}
`;
